var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53566 1.52495C8.82558 1.22911 8.82078 0.754259 8.52495 0.464339C8.22911 0.17442 7.75426 0.179217 7.46434 0.475054L8.53566 1.52495ZM3.10002 6L2.56436 6.52495C2.70542 6.66889 2.89848 6.75 3.10002 6.75C3.30156 6.75 3.49461 6.66889 3.63568 6.52495L3.10002 6ZM1.53566 3.33219C1.24574 3.03635 0.770889 3.03156 0.475052 3.32148C0.179216 3.6114 0.174421 4.08625 0.464341 4.38208L1.53566 3.33219ZM7.46434 0.475054L2.56436 5.47505L3.63568 6.52495L8.53566 1.52495L7.46434 0.475054ZM0.464341 4.38208L2.56436 6.52495L3.63567 5.47505L1.53566 3.33219L0.464341 4.38208Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ed6f2c3bfe1812529b6f7d1457982e6f.svg";
export { ForwardRef as ReactComponent };